export const makeCSSStr = (properties: Record<string, any>): string =>
  Object.entries(properties)
    .map(([k, v]) => `${k}:${v}`)
    .join(';');
